let hasWarned = false;
const hostname = window.location.hostname;
const parts = hostname.split('.');
const href = parts.length > 2 ? parts[0] : hostname; // Subdomain (DEV, COMALTX, etc) or hostname (full domain)

export let FUSION_PREFIX = '/fusion/';
export let TEAM_PREFIX = '';
export let CUSTOM_URL;

// PUBLIC_API_URL is the single source of truth for which server to target.
//   Production build: full URL, e.g. https://aggapi.overwatch.ai/demo/fusion
//   Dev server:       relative path after proxy rewrite, e.g. /demo/fusion
//
// To override during local dev without committing, set PUBLIC_API_URL in .env.local.
const envApiUrl = import.meta.env.PUBLIC_API_URL;

if (envApiUrl) {
  if (envApiUrl.startsWith('http')) {
    // Full URL — production builds or direct (non-proxied) dev
    const url = new URL(envApiUrl);
    CUSTOM_URL = url.origin; // e.g. 'https://aggapi.overwatch.ai'
    const segments = url.pathname.split('/').filter(Boolean); // ['demo', 'fusion']
    const fusionIdx = segments.lastIndexOf('fusion');
    TEAM_PREFIX = fusionIdx > 0 ? '/' + segments.slice(0, fusionIdx).join('/') : '';
  } else {
    // Relative path — dev proxy rewrote PUBLIC_API_URL to the proxy path
    // e.g. '/demo/fusion' or '/dev/fusion'
    CUSTOM_URL = '';
    const segments = envApiUrl.split('/').filter(Boolean); // ['demo', 'fusion']
    const fusionIdx = segments.lastIndexOf('fusion');
    TEAM_PREFIX = fusionIdx > 0 ? '/' + segments.slice(0, fusionIdx).join('/') : '';
  }
} else {
  // Fallback: derive from hostname (backward compat for deployments without the env var)
  if (hostname.includes('localhost')) {
    CUSTOM_URL = '';
    TEAM_PREFIX = '/dev';
  } else if (hostname.includes('192')) {
    CUSTOM_URL = '';
    TEAM_PREFIX = '/dev';
  } else if (href === 'devdemo') {
    CUSTOM_URL = 'https://devapi.overwatch.ai';
    TEAM_PREFIX = '/dev';
  } else if (href === 'staging') {
    CUSTOM_URL = 'https://aggapi.overwatch.ai';
    TEAM_PREFIX = '/staging';
  } else if (href === 'demo') {
    CUSTOM_URL = 'https://aggapi.overwatch.ai';
    TEAM_PREFIX = '/demo';
  } else {
    CUSTOM_URL = 'https://aggapi.overwatch.ai';
    TEAM_PREFIX = '/' + href;
  }
}

export function _Environment() {
  if (process.env.NODE_ENV === 'development') {
    if (!hasWarned) {
      hasWarned = true;
    }
  }

  return href.toUpperCase();
}
